// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","409":"ee9ce975","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"f93fb8fd85b4b9141d5e","409":"efb329220726942145af","691":"98bcee2f75e9325722f4"}[chunkId] + ".js";
};